import { Inject, Injectable, makeStateKey, Optional, TransferState, StateKey } from "@angular/core";
import { Store } from "@ngrx/store";
import { take } from "rxjs/operators";

import { NGRX_UTILS_CONFIG } from "../const";
import { NgrxUtilsConfig, NgrxUtilsState } from "../model";

@Injectable({
	providedIn: "root",
})
export class StateTransferService {
	readonly stateKey: StateKey<string> = makeStateKey("NGRX_STATE");

	constructor(
		private transferState: TransferState,
		private store: Store<NgrxUtilsState>,
		@Optional() @Inject(NGRX_UTILS_CONFIG) private config: NgrxUtilsConfig | undefined
	) {}

	/**
	 * Save NGRX state on the server for later use in the browser.
	 */
	saveState() {
		this.transferState.onSerialize(this.stateKey, () => {
			let state: any;
			// eslint-disable-next-line rxjs/no-ignored-subscription
			this.store.pipe(take(1)).subscribe((s) => {
				state = { ...s };

				if (!this.config || !this.config.keysToIgnore) {
					return;
				}

				for (const key of this.config.keysToIgnore) {
					delete state[key];
				}
			});
			return state;
		});
	}

	/**
	 * Retrieve NGRX state that was set previously on the server.
	 */
	getState() {
		const state = this.transferState.get(this.stateKey, undefined);
		this.transferState.remove(this.stateKey);
		return state;
	}
}
